import styled from 'styled-components';

const Background = styled.div `
    min-width: calc(100vw - 180px); /*直覺這個要跟著 Sidebar 的值跑 240 -> 180*/
    padding: 72px 0 0 180px;
    overflow-x: hidden;
    background: #fafafa;
    @media (max-width: 1170px){
        padding-left: 0;
    }
    filter: ${props => props.isUserActive ? 'blur(5px)' : ''};
    /* transition: all .2s ease-in-out; */
    ::-webkit-scrollbar{
        width: 5px;
        height: 5px;
    }
    ::-webkit-scrollbar-thumb{
        border-radius: 1em;
        background-color: rgba(50,50,50,.3);
    }
    ::-webkit-scrollbar-track{
        border-radius: 1em;
        background-color: rgba(50,50,50,.1);
    }
`
export default Background;


// WEBPACK FOOTER //
// ./src/Background.js